import get from 'lodash/get';
import * as micSectorActions from '../../action_creators/mic/mic_sector_action_creators';
import MicSectorModel from '../../../models/mic/mic_sector_model';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchMicDetail(params, store) {
  const buildSectorData = data => {
    const len = data.length;
    const results = {};
    const rows = [];
    let sectorName = '';
    let list = [];
    let elem = {
      name: data[0].sector_name,
      url: data[0].sector_url,
      list: []
    };

    if (len > 0) {
      sectorName = data[0].sector_name;
    } else {
      // results = response.base(200, 'Success!');
      results.total = 0;
      results.rows = [];
      // return callback(null, results);
    }

    // eslint-disable-next-line
    for (let index = 0; index < len; index++) {
      const row = data[index];
      if (sectorName !== row.sector_name) {
        elem.list = list;
        rows.push(elem);

        sectorName = row.sector_name;
        list = [];

        elem = {
          name: row.sector_name,
          url: row.sector_url,
          list: []
        };
      }

      list.push({
        ranking: row.ranking,
        name: row.company_name,
        url: row.url,
        for: row.why_here
      });
    }

    elem.list = list;
    rows.push(elem);

    return { rows };
  };

  return function firstDispatch(dispatch) {
    return MicSectorModel.fetch(params, store)
      .then(function handleMicDetailData(MicData) {
        const formattedSectorData = buildSectorData(MicData.data);
        dispatch(
          micSectorActions.micSectorLoaded(
            formattedSectorData,
            store,
            params.year,
            params.sector
          )
        );
      })
      .catch(function handleUserError(err) {
        if (err.message === 'Invalid Sector') {
          log.warn(
            'User tried a most creative people page with invalid sector.'
          );
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
          return dispatch(micSectorActions.micSectorLoadError(err, store));
        }

        const status = get(err, 'response.status');

        if (status === 404 || status === 401) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        }

        if (status === 500) {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in micSector actions, message: ${err.message}`);
        }

        return dispatch(micSectorActions.micSectorLoadError(err, store));
      });
  };
}
